// Lightweight, fire-and-forget analytics tracker.
// Never throws; never blocks UI. Reuses an anonymous UUID across visits via localStorage.
import { api, API } from "./api";

const ANON_KEY = "pc_anon_id";

function getAnonId() {
  if (typeof window === "undefined") return null;
  try {
    let id = window.localStorage.getItem(ANON_KEY);
    if (!id) {
      id = (window.crypto?.randomUUID?.() || `anon_${Math.random().toString(36).slice(2)}_${Date.now()}`);
      window.localStorage.setItem(ANON_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

export function track(event, props = {}) {
  try {
    const anon_id = getAnonId();
    const body = JSON.stringify({ event, props, anon_id });
    // Prefer sendBeacon for CTA clicks that immediately navigate away — guaranteed delivery.
    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      const blob = new Blob([body], { type: "application/json" });
      const ok = navigator.sendBeacon(`${API}/analytics/event`, blob);
      if (ok) return;
    }
    api.post("/analytics/event", { event, props, anon_id }).catch(() => {});
  } catch {
    // no-op
  }
}
